import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import React from "react";

const Navbar = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark mb-3 py-3">
            <div className="container">
                <a className="navbar-brand fw-bold text-white" href="/">
                    Madiha Fatima
                </a>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navmenu"
                    aria-controls="navmenu"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                
                <div className="collapse navbar-collapse justify-content-end" id="navmenu">
                    <ul className="navbar-nav align-items-lg-center">
                        <li className="nav-item p-2">
                            <a className="nav-link text-white" href="#about">
                                About
                            </a>
                        </li>
                        <li className="nav-item p-2">
                            <a className="nav-link text-white" href="#skills">
                                Skills
                            </a>
                        </li>
                        <li className="nav-item p-2">
                            <a className="nav-link text-white" href="#projects">
                                Projects
                            </a>
                        </li>
                        <li className="nav-item p-2">
                            <a className="nav-link text-white" href="#contact">
                                Contact
                            </a>
                        </li>
                        <li className="nav-item ms-3">
                            <button className="btn btn-sm btn-outline-light"><a className="link-black" target="_blank" rel="noopener noreferrer" href="https://github.com/madihamalghani">
                            GitHub
                            </a></button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
